import { isDate } from 'lodash'
import ga from 'react-ga'
import moment from 'moment'
import debug from 'debug'
import nesProp from 'nested-property'
import zipcodes from '../components/bpostSelect.json'
import * as c from 'state/constants'

const info = debug('helpers:info')

// @params: files/modelname/item id/filename/originalname[?download]
export const getFileNameAndUrl = (type, id, { filename, originalname }, download) => ({
    url: `/files/${type}/${id}/${filename}/${originalname}${download ? '?download' : ''}`,
    name: originalname,
})

// Time & date stuff

export const timeSince = (date) => {
    const seconds = Math.floor((new Date() - date) / 1000)

    let interval = Math.floor(seconds / 31536000)

    if (interval > 1) {
        return `${interval} years`
    }
    interval = Math.floor(seconds / 2592000)
    if (interval > 1) {
        return `${interval} months`
    }
    interval = Math.floor(seconds / 86400)
    if (interval > 1) {
        return `${interval} days`
    }
    interval = Math.floor(seconds / 3600)
    if (interval > 1) {
        return `${interval} hours`
    }
    interval = Math.floor(seconds / 60)
    if (interval > 1) {
        return `${interval} minutes`
    }
    return `${Math.floor(seconds)} seconds`
}

export const isValidDate = (d) => {
    if (Object.prototype.toString.call(d) !== "[object Date]") {
        return false
    }
    return !isNaN(d.getTime())
}

export const toDate = date => {
    if (!date) {
        return false
    }

    let theDate

    if (typeof date === 'string') {
        if (/\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d/.test(date)) {
            theDate = new Date(date)
        } else {
            date = date.trim()
            let parts
            if (date.split('/').length === 3) {
                parts = date.split('/')
            } else if (date.split('-').length === 3) {
                parts = date.split('-')
            } else if (date.split('.').length === 3) {
                parts = date.split('.')
            } else {
                // no idea of what was sent, return FALSE
                return false
            }
            if (parts[2].length === 4) {
                theDate = new Date(`${parts[2]}/${parts[1]}/${parts[0]}`)
            } else if (parts[0].length === 4) {
                theDate = new Date(`${parts[0]}/${parts[1]}/${parts[2]}`)
            } else {
                // no clear year
                return false
            }
        }
    } else if (isDate(date)) {
        theDate = date
    } else {
        return false
    }
    return theDate
}

/**
 * This function return with a formatted date like a string if valid,
 * else give the today date formatted to 'YYYY/MM/DD'
 * @param {*} date
 */
export const serverDateFormat = (date) => {
    if (!moment(date).isValid()) {
        return moment().format("YYYY/MM/DD")
    }

    return moment(date).format("YYYY/MM/DD")
}

export const formatDate = (date, locale = 'eu') => {
    const dateToPrettify = toDate(date)
    if (!dateToPrettify) {
        return false
    }
    if (locale === 'eu') {
        return moment(date).format("DD-MM-YYYY")
    }
    // default to ISO
    return moment(date).format("YYYY-MM-DD")
}

class DateFormatter {
    constructor(date) {
        this.date = toDate(date)
    }
    valueOf() {
        return this.date ? this.date.valueOf() : ''
    }
    toString() {
        return this.date ? formatDate(this.date, 'eu') : ''
    }
}

export const dateFormatter = (date) => {
    return new DateFormatter(date)
}

// Google maps

export const initializeMap = (el, lat, lng) => {
    if (!lat || !lng) {
        info('no latlng')
        return
    }
    // Map

    require('google-maps').load((google) => {
        const mapOptions = {
            center: {
                lat,
                lng,
            },
            zoom: 14,
            zoomControl: true,
            mapTypeControl: true,
            scaleControl: true,
            streetViewControl: true,
            rotateControl: true,
            scrollwheel: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            // streetViewControl: false,
            // panControl: false,
            disableDefaultUI: true,
        }

        // map = new google.maps.Map(document.getElementById("map"), mapOptions);
        const map = new google.maps.Map(el.get(0), mapOptions)
        el.addClass('generated')

        const marker = new google.maps.Marker({
            position: {
                lat,
                lng,
            },
            map,
            title: 'title',
        })

        marker.setMap(map)
    })
}

// If the cookie 'name' we are looking for can be found in the string,
// then the string, which lies between characters 'from' and 'to' (options.from, options.to) will be returned.
// Returned value will not contain 'from' and 'to'.
export const readCookie = (name, options) => {
    if (document.cookie.includes(name)) {
        const cookie = document.cookie.slice((document.cookie.search(name)))

        const startPos = cookie.indexOf(options.from) + 1
        const endPos = cookie.indexOf(options.to)

        return cookie.substring(startPos, endPos)
    }
    return false
}

export const fillVersion = ($here) => {
    const cp = `© ${(new Date()).getFullYear()} WILLEMOT NV`
    const version = process.env.VERSION || "dev"
    $here.find('.copyright').text(cp)
    $here.find('.version').text(version)
}

global.reacts = []
export const mountReact = (domEl, App, attrs) => {
    const React = require('react')
    const ReactDom = require('react-dom')
    const cE = React.createElement

    // ***NOTE*** this leaks unless you unmount again after using it
    ReactDom.render(cE(App, attrs), domEl)
    global.reacts.push({
        el: domEl,
        unmountFn: () => {
            global.reacts = global.reacts.filter(e => e !== domEl)
            ReactDom.unmountComponentAtNode(domEl)
        },
    })
}

// Create an application
// Right now only adds store to context
export const makeApp = (El) => {
    const React = require('react')
    const cE = React.createElement
    const { Provider } = require('react-redux')
    const store = require('state/store')

    const App = (props) => cE(Provider, { store }, cE(El, props))

    return App
}

export const trimObject = (data) => {
    const trimmed = {}
    for (const prop in data) {
        if (data[prop] != null) {
            trimmed[prop] = data[prop].trim()
        }
    }
    return trimmed
}

export const hasContent = (data) => {
    for (const prop in data) {
        if (data[prop] != null && data[prop] !== '') {
            return true
        }
    }
    return false
}

// Google Analytics
export const initializeGa = (host) => {
    if (host === 'broker.willemot.be') {
        return ga.initialize('UA-70685630-2')
    } else if (host === 'my.easinsure.be') {
        return ga.initialize('UA-70685630-1')
    }
    return
}

// Oracle provided translations handlers

/**
 * This function give a language code by a language name translated on any language supported.
 * For example: return nl if input is "Nederlands" or "Néerlandais" or "Nederlands".
 * @param {string} clientLanguage - the name of the language of the client in supported language.
 * @param {object} clientOptionsDict - oracle provided language stack
 * @returns clientLanguageCode - the code of client language "nl", "fr", "en". If no match then "nl".
 */
export const getTheLanguageCodeByAnyLanguageOnAnyLanguage = (clientLanguage, clientOptionsDict) => {
    let clientLanguageCode = ''
    let clientLanguageIndex = ''

    // finding the index in translations of the word in any language.
    if (clientOptionsDict && clientOptionsDict.TAAL) {
        let keysForClientOpsDict = Object.keys(clientOptionsDict.TAAL)
        keysForClientOpsDict.forEach((oneKeyOfDict) => {
            let languageDictInThreeLang = clientOptionsDict.TAAL[oneKeyOfDict]

            if (Object.keys(languageDictInThreeLang).length > 0) {
                let languageCodes = Object.keys(languageDictInThreeLang)
                languageCodes.forEach((code) => {
                    if (clientLanguage.localeCompare(languageDictInThreeLang[code]) === 0) {
                        clientLanguageIndex = oneKeyOfDict
                    }
                })
            }
        })
    }

    // index of word in translations decide the language code
    switch (clientLanguageIndex * 1) {
        case 1:
            clientLanguageCode = 'nl'
            break
        case 2:
            clientLanguageCode = 'fr'
            break
        case 3:
            clientLanguageCode = 'en'
            break
        default:
            clientLanguageCode = 'nl'
    }

    return clientLanguageCode
}

/**
 * This function give the language name on user language of the client language.
 * For example: return "Néerlandais" on "fr" if input is "Nederlands" or "Néerlandais" or "Nederlands".
 * @param {string} clientLanguage - the name of the language of the client in supported language.
 * @param {object} clientOptionsDict - oracle provided language stack
 * @param {string} appLanguage - language code
 * @returns clientLanguageCode - the code of client language "nl", "fr", "en". If no match then "nl".
 */
export const getTheLanguageOnAppLangByAnyLanguage = (clientLanguage, clientOptionsDict, appLanguage) => {
    let clientLanguageTranslated = ''

    // finding the translation for current user of the language name
    if (clientOptionsDict.TAAL) {
        let keysForClientOpsDict = Object.keys(clientOptionsDict.TAAL)
        keysForClientOpsDict.forEach((oneKeyOfDict) => {
            let languageDictInThreeLang = clientOptionsDict.TAAL[oneKeyOfDict]
            if (Object.keys(languageDictInThreeLang).length > 0) {
                let languageCodes = Object.keys(languageDictInThreeLang)
                languageCodes.forEach((code) => {
                    if (clientLanguage.localeCompare(languageDictInThreeLang[code]) === 0) {
                        clientLanguageTranslated = nesProp.get(languageDictInThreeLang, appLanguage)
                    }
                })
            }
        })
    }

    return clientLanguageTranslated
}

/**
 * This function give the gender name on user language.
 * @param {string} genderCode - the code of the gender
 * @param {object} clientOptionsDict - oracle provided language stack
 * @param {string} appLanguage - language code
 * @returns genderTranslated - the translation.
 */
export const getTheGenderOnAppLangByAnyCode = (genderCode, clientOptionsDict, appLanguage) => {
    let genderTranslated = genderCode
    let genderIndex = 1

    if (genderCode == 'M') {
        genderIndex = 1
    } else {
        if (genderCode == 'V' || genderCode == 'F') {
            genderIndex = 2
        }
    }

    // finding the translation for current user of the language name
    if (clientOptionsDict.GESLACHT) {
        genderTranslated = nesProp.get(clientOptionsDict, "GESLACHT." + genderIndex + "." + appLanguage) || genderCode
    }

    return genderTranslated
}

/**
 * This function find the contractId of of a claim from the contracts of the client
 * by a contract number from a claim.
 * @param {object} contracts - all of the client contracts
 * @param {string} claimContractNumber - the contractNumber of the selected claim
 * @returns {string} contractId related by the claim, else an empty string if no match of contractNumbers.
 */
export const findContractIdByContractNumber = (contracts, claimContractNumber) => {
    let matchContractId = ''

    if (contracts && (Object.keys(contracts).length > 0) && claimContractNumber) {
        Object.keys(contracts).forEach((oneContractKey) => {
            let oneContract = contracts[oneContractKey]

            // skipping other kind of module properties, only the contract matters
            if (oneContract && typeof oneContract == 'object' &&
                oneContract.hasOwnProperty('contractNumber') && oneContract.hasOwnProperty('contractId')) {
                let contractId = nesProp.get(oneContract, "contractId")
                let contractNumber = nesProp.get(oneContract, "contractNumber")

                if (claimContractNumber == contractNumber) {
                    matchContractId = contractId
                }
            }
        })
    }

    return matchContractId
}

/*
 * Generate option array based on requested object data
 * @param Object optionsData
 * @param String language
 *
 * @return array
 */
const generateOptionsObject = (optionsData, language) => {
    const optionsArray = []

    Object.keys(optionsData).map((key, index) => {
        optionsArray.push({ value: key, label: optionsData[key][language] })
    });

    return optionsArray
}

/**
 * This function create a
 *
 * @param {object} optionsData
 */
export const generateGlobalOptionsObject = (optionsData) => {
    const optionsArray = []

    Object.keys(optionsData).map((key, index) => {
        optionsArray.push({ value: key, label: optionsData[key] })
    })

    return optionsArray
}

/**
 * Generates the client dictionaries to have a same place for each dictionary
 * @param {Object} clientOptionsDict The translate list from state.client.clientOptionsDict
 * @param {string} language The language of the application - state.app.lang
 */
export const generateClientDicts = (clientOptionsDict, language) => {
    const clientDictionaries = {}

    if (clientOptionsDict == undefined) {
        return clientDictionaries
    }

    clientDictionaries['personType'] = generateOptionsObject(clientOptionsDict.PERSOONSTYPE, language)
    clientDictionaries['gender'] = generateOptionsObject(clientOptionsDict.GESLACHT, language)
    clientDictionaries['nationality'] = generateOptionsObject(clientOptionsDict.NATIONALITEIT, language)
    clientDictionaries['language'] = generateOptionsObject(clientOptionsDict.TAAL, language)
    clientDictionaries['title'] = generateOptionsObject(clientOptionsDict.AANSPREKING, language)
    clientDictionaries['licenceCategory'] = generateOptionsObject(clientOptionsDict.RB_CATEGORIE, language)
    clientDictionaries['relationType'] = generateOptionsObject(clientOptionsDict.HOEDANIGHEID, language)
    clientDictionaries['country'] = generateOptionsObject(clientOptionsDict.LAND, language)
    clientDictionaries['legalForm'] = generateOptionsObject(clientOptionsDict.RECHTSVORM, language)
    clientDictionaries['globalCountry'] = generateGlobalOptionsObject(clientOptionsDict.LAND)
    clientDictionaries['profession'] = generateOptionsObject(clientOptionsDict.profession, language)
    clientDictionaries['activSector'] = generateOptionsObject(clientOptionsDict.activSector, language)
    clientDictionaries['socialStatus'] = generateOptionsObject(clientOptionsDict.socialStatus, language)
    clientDictionaries['taxStatus'] = generateOptionsObject(clientOptionsDict.taxStatus, language)
    clientDictionaries['ppp'] = generateOptionsObject(clientOptionsDict.ppp, language)
    clientDictionaries['birthCountry'] = generateOptionsObject(clientOptionsDict.LAND, language)
    clientDictionaries['maritalStatus'] = generateOptionsObject(clientOptionsDict.maritalStatus, language)
    clientDictionaries['involvedParties'] = generateOptionsObject(clientOptionsDict.BTR_SUBTYPE, language)
    clientDictionaries['documentTypeOptions'] = generateOptionsObject(clientOptionsDict.claim, language)
    clientDictionaries['birthLocality'] = zipcodes.map(({ zip, city }) => {
        const search = city.toLowerCase().split(/[^a-z]+/).join('|')
        return {
            value: `${zip}&${city}`,
            label: `${zip} - ${city}`,
            search: `|${city}|${search}`,
        }
    })

    return clientDictionaries
}

/**
 * This function give a language code by a client type name translated on any language supported.
 * For example: return PERSON if input is "Fysisch persoon" on nl language.
 * @param {string} clientTypeWord - the name of the language of the client in supported language.
 * @param {object} clientOptionsDict - oracle provided language stack
 * @returns clientLanguageCode - the code of client type "PERSON", "COMPANY". If no match then "PERSON".
 */
export const getTheClientTypeCodeByAnyLanguageOnAnyLanguage = (clientTypeWord, clientOptionsDict) => {
    let clientTypeCode = c.CLIENT_TYPE_PERSON
    let clientTypeIndex = ''
    /*  This are the translations provided by oracle each time, from this we find the corect index.
        First is PERSON second is COMPANY
    1:
        en: "Fysisch persoon"
        fr: "Personne physique"
        nl: "Fysisch persoon"

    2:
        en: "Rechtspersoon"
        fr: "Personne morale"
        nl: "Rechtspersoon"
    */

    // finding the index in translations of the word in any language.
    if (clientOptionsDict && clientOptionsDict.PERSOONSTYPE) {
        let keysForClientOpsDict = Object.keys(clientOptionsDict.PERSOONSTYPE)
        keysForClientOpsDict.forEach((oneKeyOfDict) => {
            let languageDictInThreeLang = clientOptionsDict.PERSOONSTYPE[oneKeyOfDict]

            if (Object.keys(languageDictInThreeLang).length > 0) {
                let languageCodes = Object.keys(languageDictInThreeLang) // nl fr en
                languageCodes.forEach((code) => {
                    if (clientTypeWord.localeCompare(languageDictInThreeLang[code]) === 0) {
                        clientTypeIndex = oneKeyOfDict
                    }
                })
            }
        })
    }

    // index of word in translations decide the type code
    switch (clientTypeIndex * 1) {
        case 1:
            clientTypeCode = c.CLIENT_TYPE_PERSON
            break
        case 2:
            clientTypeCode = c.CLIENT_TYPE_COMPANY
            break
        default:
            clientTypeCode = c.CLIENT_TYPE_PERSON
    }

    return clientTypeCode
}


export const trimCharacterFromLeft = (str, ch) => {
    var start = 0,
        end = str.length;

    while (start < end && str[start] === ch)
        ++start;

    /* while(end > start && str[end - 1] === ch)
        --end; */

    return (start > 0 || end < str.length) ? str.substring(start, end) : str;
}

export const canSendInvitation = (dsPackage) => {
    const statusBlackList = ['packageStatusExpired', 'packageStatusRejected', 'packageStatusRevoked', 'packageStatusFailed',
        'packageStatusFinished', 'documentsDownloaded', 'documentsTransferredToOracle', 'documentError',
        'packageStatusDeleted', 'packageStatusDraft', 'emailSentWithSignedDocs', 'generalError'
    ]
    let blocked = false

    if (dsPackage && dsPackage.statusHistory) {
        dsPackage.statusHistory.forEach((oneStatus) => {
            if (statusBlackList.includes(oneStatus.status)) {
                blocked = true
            }
        })
    }

    const packageStatusError = dsPackage.status === c.DS_DOCUMENTS_GENERAL_ERROR || blocked

    // case fo failed package does not send remainder
    return !packageStatusError ? true : false
}

/**
 * Converts a string to a boolean
 * @param {string} string e.g. 'true' or 'false'
 * @returns {boolean}
 */
export const stringToBoolean = (string) => {
    if (typeof string === 'boolean') return string // eslint-disable-line curly
    if (typeof string === 'string') {
        if (string === 'true') return true // eslint-disable-line curly
        if (string === 'false') return false // eslint-disable-line curly
    }
    return false // Default false value
}



// WEBPACK FOOTER //
// ./lib/helpers.js